import { FaUpload } from "react-icons/fa";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

const Api2Form = ({ state, updateState }) => {
    const formData = state.formData || {};
    const CLIMATIQ_API_KEY = process.env.REACT_APP_CLIMATIQ_API_KEY || 'Y2ZBNWZKRzRGNzJYNjRQMzpa';
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const handleInputMethodChange = (method) => {
        updateState({ formData: { ...formData, inputMethod: method } });
    };

    const handleAddMonthlyEntry = () => {
        const monthlyData = formData.monthlyData || [];
        updateState({ formData: { ...formData, monthlyData: [...monthlyData, { month: '', site: '', value: '' }] } });
    };

    const handleMonthlyDataChange = (index, field, value) => {
        const monthlyData = [...(formData.monthlyData || [])];
        monthlyData[index] = { ...monthlyData[index], [field]: value };
        updateState({ formData: { ...formData, monthlyData } });
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            updateState({ formData: { ...formData, uploadedFile: file } });
            toastr.success(`File selected: ${file.name}`);
        }
    };

    return (
        <div className="max-w-4xl mx-auto px-4 py-8 pb-24">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                <div className="p-8">
                    <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <p className="text-sm text-yellow-800">
                            <strong>API Status:</strong> {CLIMATIQ_API_KEY && CLIMATIQ_API_KEY !== 'Y2ZBNWZKRzRGNzJYNjRQMzpa' ?
                                '✅ API Key Configured' : '❌ Please set REACT_APP_CLIMATIQ_API_KEY in .env file'}
                        </p>
                    </div>

                    <div className="mb-8">
                        <label className="block text-lg font-semibold text-gray-700 mb-4">
                            What is the total amount of electricity the company draws from the grid, per month, in kWh per site (or MWh)?
                        </label>
                        <p className="text-sm text-gray-600 mb-4">
                            If you do not have this information, please upload a recent monthly electricity bill and EcoMina will extract the kWh.
                        </p>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-3">Select input method:</label>
                            <div className="grid grid-cols-2 gap-4">
                                <button
                                    onClick={() => handleInputMethodChange('manual')}
                                    className={`p-4 rounded-lg border-2 transition-all bg-white ${formData.inputMethod === 'manual'
                                            ? 'border-green-500 bg-green-50'
                                            : 'border-gray-200 hover:border-gray-300'
                                        }`}
                                >
                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="radio"
                                            checked={formData.inputMethod === 'manual'}
                                            onChange={() => handleInputMethodChange('manual')}
                                            className="w-5 h-5 text-green-600"
                                        />
                                        <span className="font-medium">Enter manually</span>
                                    </div>
                                </button>
                                <button
                                    onClick={() => handleInputMethodChange('upload')}
                                    className={`p-4 rounded-lg border-2 transition-all bg-white ${formData.inputMethod === 'upload'
                                            ? 'border-green-500 bg-green-50'
                                            : 'border-gray-200 hover:border-gray-300'
                                        }`}
                                >
                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="radio"
                                            checked={formData.inputMethod === 'upload'}
                                            onChange={() => handleInputMethodChange('upload')}
                                            className="w-5 h-5 text-green-600"
                                        />
                                        <span className="font-medium">Upload bill</span>
                                    </div>
                                </button>
                            </div>
                        </div>

                        {formData.inputMethod === 'manual' && (
                            <div className="space-y-4">
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Unit:</label>
                                    <div className="flex space-x-4">
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                name="unit"
                                                value="kWh"
                                                checked={formData.unit === 'kWh'}
                                                onChange={(e) => updateState({ formData: { ...formData, unit: e.target.value } })}
                                                className="w-5 h-5 text-green-600"
                                            />
                                            <span>kWh</span>
                                        </label>
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                name="unit"
                                                value="MWh"
                                                checked={formData.unit === 'MWh'}
                                                onChange={(e) => updateState({ formData: { ...formData, unit: e.target.value } })}
                                                className="w-5 h-5 text-green-600"
                                            />
                                            <span>MWh</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <button
                                        onClick={handleAddMonthlyEntry}
                                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all"
                                    >
                                        + Add Monthly Entry
                                    </button>
                                </div>

                                {(formData.monthlyData || []).map((entry, index) => (
                                    <div key={index} className="grid grid-cols-3 gap-4 p-4 bg-gray-50 rounded-lg">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Month</label>
                                            <select
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                                value={entry.month}
                                                onChange={(e) => handleMonthlyDataChange(index, 'month', e.target.value)}
                                            >
                                                <option value="">Select month</option>
                                                {months.map(month => (
                                                    <option key={month} value={month}>{month}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Site</label>
                                            <input
                                                type="text"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                                placeholder="Site name"
                                                value={entry.site}
                                                onChange={(e) => handleMonthlyDataChange(index, 'site', e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Value ({formData.unit || 'kWh'})</label>
                                            <input
                                                type="number"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                                placeholder={`Enter ${formData.unit || 'kWh'}`}
                                                value={entry.value}
                                                onChange={(e) => handleMonthlyDataChange(index, 'value', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {formData.inputMethod === 'upload' && (
                            <div className="border-2 border-gray-200 border-dashed rounded-lg p-6 text-center">
                                <input
                                    type="file"
                                    className="hidden"
                                    id="electricity-bill-upload"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    onChange={handleFileUpload}
                                />
                                <label
                                    htmlFor="electricity-bill-upload"
                                    className="cursor-pointer flex flex-col items-center space-y-3"
                                >
                                    <FaUpload className="w-12 h-12 text-green-600" />
                                    <span className="text-green-600 font-medium">Click to upload electricity bill</span>
                                    <span className="text-sm text-gray-500">PDF, JPG, or PNG</span>
                                </label>
                                {formData.uploadedFile && (
                                    <p className="mt-4 text-sm text-gray-600">
                                        Selected: {formData.uploadedFile.name}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>

                    {state.calculationResults && Object.keys(state.calculationResults).length > 0 && (
                        <div className="mt-8 p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg border border-green-200">
                            <h3 className="text-lg font-semibold text-gray-800 mb-4">Calculation Results</h3>
                            <div className="space-y-3">
                                {Object.entries(state.calculationResults).map(([key, result]) => (
                                    <div key={key} className="flex justify-between items-center p-3 bg-white rounded-lg border">
                                        <div>
                                            <span className="font-medium text-gray-700">
                                                {result.month && result.site ? `${result.month} - ${result.site}` : result.description}
                                            </span>
                                            <br />
                                            <span className="text-sm text-gray-500">
                                                {result.energy} {result.unit}
                                            </span>
                                        </div>
                                        <span className="font-semibold text-green-700">
                                            {result.co2e?.toFixed(2)} {result.co2e_unit}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


export default Api2Form;